(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("tc39-proposal-temporal"), require("@bingads-webui-universal/time-zone-converter"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "tc39-proposal-temporal", "@bingads-webui-universal/time-zone-converter"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("tc39-proposal-temporal"), require("@bingads-webui-universal/time-zone-converter")) : factory(root["underscore"], root["tc39-proposal-temporal"], root["@bingads-webui-universal/time-zone-converter"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__91__, __WEBPACK_EXTERNAL_MODULE__95__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 88);
/******/ })
/************************************************************************/
/******/ ({

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(89);


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DefaultSpecificRanges: true,
  RANGES: true,
  ComparedOptions: true,
  generateDateData: true,
  getRangesFromData: true,
  translateLegacyToIANATimezone: true,
  parseCivilDate: true,
  formatCivilDate: true
};
Object.defineProperty(exports, "DefaultSpecificRanges", {
  enumerable: true,
  get: function get() {
    return _defaultSpecificRanges.DefaultSpecificRanges;
  }
});
Object.defineProperty(exports, "RANGES", {
  enumerable: true,
  get: function get() {
    return _defaultSpecificRanges.RANGES;
  }
});
Object.defineProperty(exports, "ComparedOptions", {
  enumerable: true,
  get: function get() {
    return _comparedOptions.ComparedOptions;
  }
});
Object.defineProperty(exports, "generateDateData", {
  enumerable: true,
  get: function get() {
    return _dateUtil.generateDateData;
  }
});
Object.defineProperty(exports, "getRangesFromData", {
  enumerable: true,
  get: function get() {
    return _dateUtil.getRangesFromData;
  }
});
Object.defineProperty(exports, "translateLegacyToIANATimezone", {
  enumerable: true,
  get: function get() {
    return _dateUtil.translateLegacyToIANATimezone;
  }
});
Object.defineProperty(exports, "parseCivilDate", {
  enumerable: true,
  get: function get() {
    return _dateUtil.parseCivilDate;
  }
});
Object.defineProperty(exports, "formatCivilDate", {
  enumerable: true,
  get: function get() {
    return _dateUtil.formatCivilDate;
  }
});

var _index = __webpack_require__(90);

Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _index[key];
    }
  });
});

var _defaultSpecificRanges = __webpack_require__(92);

var _comparedOptions = __webpack_require__(93);

var _dateUtil = __webpack_require__(94);

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDateInvalid = isDateInvalid;
exports.getCivilDateMonthStart = getCivilDateMonthStart;
exports.getCivilDateMonthEnd = getCivilDateMonthEnd;
exports.compareCivilMonth = compareCivilMonth;
exports.compareCivilDate = compareCivilDate;
exports.getMinDate = getMinDate;
exports.getMaxDate = getMaxDate;
exports.isCivilDateInRange = isCivilDateInRange;
exports.isCivilMonthInRange = isCivilMonthInRange;
exports.getCivilDateDayOfWeek = getCivilDateDayOfWeek;
exports.getCivilDateToday = getCivilDateToday;
exports.isCivilDateRangeStartOrEnd = isCivilDateRangeStartOrEnd;
exports.getThisSunday = getThisSunday;
exports.getThisSaturday = getThisSaturday;
exports.getLastMonday = getLastMonday;
exports.getLastSunday = getLastSunday;
exports.getNextMonday = getNextMonday;
exports.getNextSunday = getNextSunday;
exports.getNextSaturday = getNextSaturday;
exports.getNextNextSunday = getNextNextSunday;
exports.getNextNextSaturday = getNextNextSaturday;
exports.isDateAvailable = isDateAvailable;
exports.isRangeValid = isRangeValid;
exports.isRangeDateAvailable = isRangeDateAvailable;
exports.getDaysOfARange = getDaysOfARange;
exports.getMonthsOfARange = getMonthsOfARange;
exports.isTheSameRange = isTheSameRange;
exports.getThisMonday = exports.isCivilDateInOpenRange = exports.minCivilDate = exports.maxCivilDate = exports.getCivilDateFromDate = exports.isValidDate = exports.MIN_VALUE = exports.MAX_VALUE = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _tc39ProposalTemporal = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MAX_VALUE = 8640000000000000;
exports.MAX_VALUE = MAX_VALUE;
const MIN_VALUE = -8640000000000000;
exports.MIN_VALUE = MIN_VALUE;

function isDateInvalid(date) {
  const year = _underscore.default.get(date, 'year');

  const month = _underscore.default.get(date, 'month');

  const day = _underscore.default.get(date, 'day');

  return _underscore.default.isNaN(year) || _underscore.default.isUndefined(year) || _underscore.default.isNull(year) || _underscore.default.isNaN(month) || _underscore.default.isUndefined(month) || _underscore.default.isNull(month) || _underscore.default.isNaN(day) || _underscore.default.isUndefined(day) || _underscore.default.isNull(day);
} // Returns a date that is the first day of the month of the provided date.


function getCivilDateMonthStart(date) {
  return new _tc39ProposalTemporal.CivilDate(date.year, date.month, 1);
} // Returns a date that is the last day of the month of the provided date.


function getCivilDateMonthEnd(date) {
  return new _tc39ProposalTemporal.CivilDate(date.year, date.month + 1, 0);
} // Checks whether the date is valid.


const isValidDate = value => _underscore.default.isDate(value) && !_underscore.default.isNaN(value.getTime()); // Get a Civil Date from Date object


exports.isValidDate = isValidDate;

const getCivilDateFromDate = value => isValidDate(value) ? new _tc39ProposalTemporal.CivilDate(value.getFullYear(), value.getMonth() + 1, value.getDate()) : null;

exports.getCivilDateFromDate = getCivilDateFromDate;
const maxCivilDate = getCivilDateFromDate(new Date(MAX_VALUE));
exports.maxCivilDate = maxCivilDate;
const minCivilDate = getCivilDateFromDate(new Date(MIN_VALUE)); // Compare the month parts of two dates. A negative value if date1 is earlier than date2,
// 0 if the dates are equal, or a positive value if date1 is later than date2.

exports.minCivilDate = minCivilDate;

function compareCivilMonth(date1, date2) {
  if (date1.year !== date2.year) {
    return date1.year - date2.year;
  }

  return date1.month - date2.month;
} // Compare the date parts of two dates. A negative value if date1 is earlier than date2,
// 0 if the dates are equal, or a positive value if date1 is later than date2.


function compareCivilDate(date1, date2) {
  if (date1.year !== date2.year) {
    return date1.year - date2.year;
  } else if (date1.month !== date2.month) {
    return date1.month - date2.month;
  }

  return date1.day - date2.day;
}

function getMinDate(date1, date2) {
  if (isDateInvalid(date1)) {
    return date2;
  }

  if (isDateInvalid(date2)) {
    return date1;
  }

  if (compareCivilDate(date1, date2) <= 0) {
    return date1;
  }

  return date2;
}

function getMaxDate(date1, date2) {
  if (isDateInvalid(date1)) {
    return date2;
  }

  if (isDateInvalid(date2)) {
    return date1;
  }

  if (compareCivilDate(date1, date2) >= 0) {
    return date1;
  }

  return date2;
} // Checks whether the specified date is in the given date range.


function isCivilDateInRange(date, {
  start,
  end
}) {
  if (start && end) {
    if (compareCivilDate(start, date) >= 0 && compareCivilDate(end, date) <= 0 || compareCivilDate(start, date) <= 0 && compareCivilDate(end, date) >= 0) {
      return true;
    }
  }

  return false;
} // Checks whether the specified date is in the given date open range
// eslint-disable-next-line max-len


const isCivilDateInOpenRange = ({
  minDate = minCivilDate,
  maxDate = maxCivilDate,
  value
}) => {
  if (!value) {
    return false;
  }

  return isCivilDateInRange(value, {
    start: minDate,
    end: maxDate
  });
}; // Checks whether the month of the specified date is in the given date range.


exports.isCivilDateInOpenRange = isCivilDateInOpenRange;

function isCivilMonthInRange(date, {
  start,
  end
}) {
  if (start && end) {
    return compareCivilMonth(start, date) >= 0 && compareCivilMonth(end, date) <= 0 || compareCivilMonth(start, date) <= 0 && compareCivilMonth(end, date) >= 0;
  }

  return false;
} // TODO: remove it and use civildate own function to do this.
// There is a issue tracking this function: https://github.com/tc39/proposal-temporal/issues/69


function getCivilDateDayOfWeek(civilDate) {
  return new Date(civilDate.year, civilDate.month - 1, civilDate.day).getDay();
} // get a date that is the monday of this week(monday - sunday)


const getThisMonday = (date, includeToday = true) => {
  if (isDateInvalid(date) || date.plus == null) {
    return null;
  }

  if (includeToday) {
    return getCivilDateDayOfWeek(date) === 0 ? date.plus({
      days: -6
    }) : date.plus({
      days: -getCivilDateDayOfWeek(date) + 1
    });
  } // map [1, 2, 3, 4, 5, 6, 0] to [7, 1, 2, 3, 4, 5, 6]


  const dayOfWeek = getCivilDateDayOfWeek(date);

  if (dayOfWeek === 1) {
    return date.plus({
      days: -7
    });
  }

  return date.plus({
    days: -((dayOfWeek + 6) % 7)
  });
};

exports.getThisMonday = getThisMonday;

function getCivilDateToday() {
  return getCivilDateFromDate(new Date());
} // Checks whether the specified date is the the given date range start or end.


function isCivilDateRangeStartOrEnd(date, dateRange) {
  return _underscore.default.some(dateRange, d => compareCivilDate(date, d) === 0);
}

function withDateChecker(date, func) {
  if (isDateInvalid(date) || date.plus == null) {
    return null;
  }

  return func();
}

function getThisSunday(date, includeToday = true) {
  // map [1, 2, 3, 4, 5, 6, 0] to [1, 2, 3, 4, 5, 6, 0]
  return withDateChecker(date, () => {
    const dayOfWeek = getCivilDateDayOfWeek(date);

    if (!includeToday && dayOfWeek === 0) {
      return date.plus({
        days: -7
      });
    }

    return date.plus({
      days: -dayOfWeek
    });
  });
}

function getThisSaturday(date, includeToday = true) {
  // map [1, 2, 3, 4, 5, 6, 0] to [2, 3, 4, 5, 6, 0, 1]
  return withDateChecker(date, () => {
    const dayOfWeek = getCivilDateDayOfWeek(date);

    if (!includeToday && dayOfWeek === 6) {
      return date.plus({
        days: -7
      });
    }

    return date.plus({
      days: -((dayOfWeek + 1) % 7)
    });
  });
}

function getLastMonday(date, includeToday = true) {
  // map [1, 2, 3, 4, 5, 6, 0] to [0, 1, 2, 3, 4, 5, 6]
  return withDateChecker(date, () => {
    const dayOfWeek = getCivilDateDayOfWeek(date);

    if (!includeToday && dayOfWeek === 1) {
      return date.plus({
        days: -14
      });
    }

    return date.plus({
      days: -((dayOfWeek + 6) % 7 + 7)
    });
  });
}

function getLastSunday(date, includeToday = true) {
  return withDateChecker(date, () => {
    const dayOfWeek = getCivilDateDayOfWeek(date);

    if (!includeToday && dayOfWeek === 0) {
      return date.plus({
        days: -14
      });
    }

    return date.plus({
      days: -(dayOfWeek + 7)
    });
  });
}

function getNextMonday(date, includeToday = false) {
  return withDateChecker(date, () => {
    if (includeToday) {
      // map [1, 2, 3, 4, 5, 6, 0] to [0, 6, 5, 4, 3, 2, 1]
      const dayOfWeek = getCivilDateDayOfWeek(date);
      return date.plus({
        days: (7 - dayOfWeek + 1) % 7
      });
    }

    const dayOfWeek = getCivilDateDayOfWeek(date);
    return date.plus({
      days: -((dayOfWeek + 6) % 7) + 7
    });
  });
}

function getNextSunday(date, includeToday = false) {
  return withDateChecker(date, () => {
    if (includeToday) {
      const dayOfWeek = getCivilDateDayOfWeek(date);
      return date.plus({
        days: (7 - dayOfWeek) % 7
      });
    }

    const dayOfWeek = getCivilDateDayOfWeek(date);
    return date.plus({
      days: -dayOfWeek + 7
    });
  });
}

function getNextSaturday(date, includeToday = false) {
  return withDateChecker(date, () => {
    if (includeToday) {
      // map [1, 2, 3, 4, 5, 6, 0] to [5, 4, 3, 2, 1, 0, 6]
      const dayOfWeek = getCivilDateDayOfWeek(date);
      return date.plus({
        days: (6 - dayOfWeek) % 7
      });
    }

    const dayOfWeek = getCivilDateDayOfWeek(date);
    return date.plus({
      days: -((dayOfWeek + 1) % 7) + 7
    });
  });
}

function getNextNextSunday(date, includeToday = false) {
  return withDateChecker(date, () => {
    const dayOfWeek = getCivilDateDayOfWeek(date);

    if (includeToday && dayOfWeek === 0) {
      return date.plus({
        days: 7
      });
    }

    return date.plus({
      days: -dayOfWeek + 14
    });
  });
}

function getNextNextSaturday(date, includeToday = false) {
  return withDateChecker(date, () => {
    const dayOfWeek = getCivilDateDayOfWeek(date);

    if (includeToday && dayOfWeek === 6) {
      return date.plus({
        days: 7
      });
    }

    return date.plus({
      days: -((dayOfWeek + 1) % 7) + 14
    });
  });
}

function isDateAvailable(date, minDate, maxDate) {
  if (isDateInvalid(date) || isDateInvalid(minDate) || isDateInvalid(maxDate)) {
    return false;
  }

  return isCivilDateInRange(date, {
    start: minDate,
    end: maxDate
  });
}

function isRangeValid(range) {
  const start = _underscore.default.get(range, 'start');

  const end = _underscore.default.get(range, 'end');

  if (isDateInvalid(start) || isDateInvalid(end)) {
    return false;
  }

  return compareCivilDate(start, end) <= 0;
}

function isRangeDateAvailable(range, minDate, maxDate) {
  if (!isRangeValid(range)) {
    return false;
  }

  const start = _underscore.default.get(range, 'start');

  const end = _underscore.default.get(range, 'end');

  return isDateAvailable(start, minDate, maxDate) && isDateAvailable(end, minDate, maxDate);
}

function getDaysOfARange(range) {
  if (!isRangeValid(range)) {
    return 0;
  }

  const end = _underscore.default.get(range, 'end');

  const start = _underscore.default.get(range, 'start');

  const t2 = new Date(end.year, end.month - 1, end.day).getTime();
  const t1 = new Date(start.year, start.month - 1, start.day).getTime(); // eslint-disable-next-line radix

  const difference = Math.round((t2 - t1) / (24 * 3600 * 1000));
  return difference + 1;
}

function getMonthsOfARange(range) {
  if (!isRangeValid(range)) {
    return 0;
  }

  const end = _underscore.default.get(range, 'end');

  const start = _underscore.default.get(range, 'start');

  if (end.year === start.year) {
    return end.month - start.month + 1;
  }

  const fullYears = end.year - start.year - 1;
  return fullYears * 12 + (12 - start.month + 1) + end.month;
}

function isTheSameRange(range1, range2) {
  const start1 = _underscore.default.get(range1, 'start');

  const start2 = _underscore.default.get(range2, 'start');

  const end1 = _underscore.default.get(range1, 'end');

  const end2 = _underscore.default.get(range2, 'end');

  if (isDateInvalid(start1) || isDateInvalid(start2) || isDateInvalid(end1) || isDateInvalid(end2)) {
    return false;
  }

  return compareCivilDate(start1, start2) === 0 && compareCivilDate(end1, end2) === 0;
}

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__91__;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultSpecificRanges = exports.RANGES = void 0;

var _tc39ProposalTemporal = __webpack_require__(91);

var _index = __webpack_require__(90);

const RANGES = {
  Yesterday: 1,
  Last7Days: 2,
  Today: 3,
  Custom: 4,
  Last30Days: 5,
  Last14Days: 6,
  ThisWeek: 7,
  ThisWeekMon: 8,
  LastWeek: 9,
  ThisMonth: 10,
  LastMonth: 11,
  Last3Months: 12,
  Last6Months: 13,
  LastWeekMon: 14,
  ThisYear: 15,
  LastYear: 16,
  EntireTimeLast18Months: 17,
  EntireTimeLast5Years: 18,
  EntireTime: 22
};
exports.RANGES = RANGES;

const DefaultSpecificRanges = (i18n, timeZone) => {
  const todayObj = i18n.getToday({
    timeZone
  });
  const today = new _tc39ProposalTemporal.CivilDate(todayObj.year, todayObj.month, todayObj.day);
  const yesterday = today.plus({
    days: -1
  });
  const thisSunday = today.plus({
    days: -(0, _index.getCivilDateDayOfWeek)(today)
  });
  const thisMonday = (0, _index.getThisMonday)(today);
  const last7day = today.plus({
    days: -7
  });
  const last14day = today.plus({
    days: -14
  });
  const last30day = today.plus({
    days: -30
  });
  const lastMonday = today.plus({
    days: -(0, _index.getCivilDateDayOfWeek)(today) - 6
  });
  const lastSunday = today.plus({
    days: -(0, _index.getCivilDateDayOfWeek)(today) - 7
  });
  const lastSaturday = today.plus({
    days: -(0, _index.getCivilDateDayOfWeek)(today) - 1
  });
  const thisMonthFirstDay = (0, _index.getCivilDateMonthStart)(today);
  const lastMonthlastDay = thisMonthFirstDay.plus({
    days: -1
  });
  const lastMonthFirstDay = (0, _index.getCivilDateMonthStart)(lastMonthlastDay);
  const minSupportDay = today.plus({
    years: -3
  });
  return [{
    rangeId: RANGES.Custom,
    key: 'Custom',
    range: {
      start: undefined,
      end: undefined
    }
  }, {
    rangeId: RANGES.Today,
    key: 'Today',
    range: {
      start: today,
      end: today
    }
  }, {
    rangeId: RANGES.Yesterday,
    key: 'Yesterday',
    range: {
      start: yesterday,
      end: yesterday
    }
  }, {
    rangeId: RANGES.ThisWeek,
    key: 'ThisWeek',
    range: {
      start: thisSunday,
      end: today
    }
  }, {
    rangeId: RANGES.ThisWeekMon,
    key: 'ThisWeekMon',
    range: {
      start: thisMonday,
      end: today
    }
  }, {
    rangeId: RANGES.Last7Days,
    key: 'Last7Days',
    range: {
      start: last7day,
      end: yesterday
    }
  }, {
    rangeId: RANGES.LastWeek,
    key: 'LastWeek',
    range: {
      start: lastSunday,
      end: lastSaturday
    }
  }, {
    rangeId: RANGES.LastWeekMon,
    key: 'LastWeekMon',
    range: {
      start: lastMonday,
      end: thisSunday
    }
  }, {
    rangeId: RANGES.Last14Days,
    key: 'Last14Days',
    range: {
      start: last14day,
      end: yesterday
    }
  }, {
    rangeId: RANGES.ThisMonth,
    key: 'ThisMonth',
    range: {
      start: thisMonthFirstDay,
      end: today
    }
  }, {
    rangeId: RANGES.LastMonth,
    key: 'LastMonth',
    range: {
      start: lastMonthFirstDay,
      end: lastMonthlastDay
    }
  }, {
    rangeId: RANGES.Last30Days,
    key: 'Last30Days',
    range: {
      start: last30day,
      end: yesterday
    }
  }, {
    rangeId: RANGES.EntireTime,
    key: 'EntireTime',
    range: {
      start: minSupportDay,
      end: today
    }
  }];
};

exports.DefaultSpecificRanges = DefaultSpecificRanges;

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparedOptions = exports.ComparedType = void 0;

var _dateUtil = __webpack_require__(94);

const ComparedType = {
  LastPeriod: 0,
  LastMonth: 1,
  LastYear: 2,
  Custom: 3
};
exports.ComparedType = ComparedType;
const ComparedOptions = [{
  type: ComparedType.LastPeriod,
  textToExport: 'Previous period',
  keyToExport: 'previousPeriod',
  get: (range, specificRangeId) => {
    switch (specificRangeId) {
      // this week
      case 7:
      case 8:
        return {
          start: range.start.plus({
            days: -7
          }),
          end: range.end.plus({
            days: -7
          })
        };
      // this month

      case 10:
        return {
          start: (0, _dateUtil.getLastMonth)(range.start),
          end: (0, _dateUtil.getLastMonth)(range.end)
        };

      default:
        {
          const t2 = new Date(range.end.year, range.end.month - 1, range.end.day).getTime();
          const t1 = new Date(range.start.year, range.start.month - 1, range.start.day).getTime(); // eslint-disable-next-line radix

          const difference = parseInt((t2 - t1) / (24 * 3600 * 1000));
          return {
            start: range.start.plus({
              days: -1 - difference
            }),
            end: range.start.plus({
              days: -1
            })
          };
        }
    }
  }
}, {
  type: ComparedType.LastMonth,
  textToExport: 'Last month',
  keyToExport: 'lastMonth',
  get: range => ({
    start: (0, _dateUtil.getLastMonth)(range.start),
    end: (0, _dateUtil.getLastMonth)(range.end)
  })
}, {
  type: ComparedType.LastYear,
  textToExport: 'Same period last year',
  keyToExport: 'samePeriodLastYear',
  get: range => ({
    start: range.start.plus({
      years: -1
    }),
    end: range.end.plus({
      years: -1
    })
  })
}, {
  type: ComparedType.Custom,
  textToExport: 'Custom',
  keyToExport: 'customPeriod',
  get: () => ({
    start: undefined,
    end: undefined
  })
}];
exports.ComparedOptions = ComparedOptions;

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRangesFromData = exports.generateDateData = exports.translateLegacyToIANATimezone = exports.parseCivilDate = exports.getDateObj = exports.formatCivilDate = exports.getLastMonth = void 0;

var _tc39ProposalTemporal = __webpack_require__(91);

var _timeZoneConverter = __webpack_require__(95);

/* eslint-disable max-len */
const getLastMonth = date => {
  let lastMonthDate = date.plus({
    months: -1
  });

  if (lastMonthDate.day !== date.day) {
    lastMonthDate = lastMonthDate.plus({
      days: -lastMonthDate.day
    });
  }

  return lastMonthDate;
};

exports.getLastMonth = getLastMonth;

const formatCivilDate = ({
  i18n,
  date,
  dateFormat = 'M/d/yyyy'
}) => `${date ? i18n.formatCivilDate(date, {
  raw: dateFormat
}) : ''}`;

exports.formatCivilDate = formatCivilDate;

const getDateObj = ({
  i18n,
  dateString,
  dateFormat
}) => {
  if (!dateString) {
    return null;
  }

  if (dateFormat) {
    return i18n.parseCivilDate(dateString, {
      raw: dateFormat
    });
  }

  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return year && month && day ? {
    year,
    month,
    day
  } : null;
};

exports.getDateObj = getDateObj;

const parseCivilDate = ({
  i18n,
  dateString,
  dateFormat
}) => {
  const dateObj = getDateObj({
    i18n,
    dateString,
    dateFormat
  });
  return dateObj ? new _tc39ProposalTemporal.CivilDate(dateObj.year, dateObj.month, dateObj.day) : undefined;
};

exports.parseCivilDate = parseCivilDate;

const translateLegacyToIANATimezone = legacyTimeZone => (0, _timeZoneConverter.toIANATimeZone)((0, _timeZoneConverter.fromLegacyTimeZone)(legacyTimeZone));

exports.translateLegacyToIANATimezone = translateLegacyToIANATimezone;

const generateDateData = (i18n, dateFromDatePicker, dateFormat, lcid) => {
  const formattedStart = dateFromDatePicker.selectedComparedRange ? formatCivilDate({
    i18n,
    date: dateFromDatePicker.selectedComparedRange.start,
    dateFormat
  }) : null;
  const formattedEnd = dateFromDatePicker.selectedComparedRange ? formatCivilDate({
    i18n,
    date: dateFromDatePicker.selectedComparedRange.end,
    dateFormat
  }) : null;
  let compared;

  if (!formattedStart && !formattedEnd) {
    compared = null;
  } else {
    compared = {
      formattedStart,
      formattedEnd,
      text: dateFromDatePicker.comparedOption && dateFromDatePicker.comparedOption.textToExport,
      key: dateFromDatePicker.comparedOption && dateFromDatePicker.comparedOption.keyToExport,
      start: i18n.parseDate(formattedStart),
      end: i18n.parseDate(formattedEnd)
    };
  }

  const date = {
    RangeStartDate: formatCivilDate({
      i18n,
      date: dateFromDatePicker.selectedRange.start,
      dateFormat
    }),
    RangeEndDate: formatCivilDate({
      i18n,
      date: dateFromDatePicker.selectedRange.end,
      dateFormat
    }),
    RangeId: dateFromDatePicker.rangeType.rangeId,
    Rangelcid: lcid,
    compared,
    RangeIndex: dateFromDatePicker.rangeIndex,
    RangeDays: dateFromDatePicker.rangeDays
  };
  return date;
};

exports.generateDateData = generateDateData;

const getRangesFromData = (i18n, dateData, dateFormat, lcid) => {
  if (!dateData || dateData.Rangelcid !== lcid) {
    return {
      selectedRange: undefined,
      selectedComparedRange: undefined
    };
  }

  const RangeStartDate = dateData.RangeStartDate,
        RangeEndDate = dateData.RangeEndDate,
        compared = dateData.compared;
  return {
    selectedRange: {
      start: RangeStartDate ? parseCivilDate({
        i18n,
        dateString: RangeStartDate,
        dateFormat
      }) : undefined,
      end: RangeEndDate ? parseCivilDate({
        i18n,
        dateString: RangeEndDate,
        dateFormat
      }) : undefined
    },
    selectedComparedRange: {
      start: compared && compared.formattedStart ? parseCivilDate({
        i18n,
        dateString: compared.formattedStart,
        dateFormat
      }) : undefined,
      end: compared && compared.formattedEnd ? parseCivilDate({
        i18n,
        dateString: compared.formattedEnd,
        dateFormat
      }) : undefined
    }
  };
};

exports.getRangesFromData = getRangesFromData;

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__95__;

/***/ })

/******/ });
});
